import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';

export const usePrintSettings = (printSettingKey) => {
  return useSelector((state) => {
    const globalPrintSettings = Global.selectPrintSettingsPrintSettings(state);
    return globalPrintSettings?.[printSettingKey];
  });
};
